import React from 'react';
import Modal from 'react-modal';

/** Popup d'information affiché au survol de l'identifiant d'une dameuse */
export default class extends React.Component {
  render() {
    const {groomer} = this.props;
    const drivers = groomer.drivers.split('\n').map(d => d.split(/, ?/)).filter(d => d.length === 3);
    const modalStyle = {
      overlay: {
        backgroundColor: 'rgba(0,0,0,0)',
        zIndex: 100000,
        pointerEvents: 'none'
      },
      content: {
        left: '20%',
        top: `calc(222px + ${this.props.idx * 25}px)`
      }
    };

    let driversPanel = null;

    if (drivers.length) {

      driversPanel = (
        <div className="drivers">
          {
            drivers.map((d, i) => {
              return (
                <div className="driver" key={i}>
                  <i className="mi mi-account-circle"/>
                  <span>{d[0]}({d[2]})</span>
                  <span>{d[1]}</span>
                </div>
              );
            })
          }
        </div>
      );
    }

    return (
      <Modal isOpen={true} contentLabel="Justification" style={modalStyle} className="groomer-popup">
        <div className={`groomer-status groomer-status-bg ${groomer.status}`}>
          { groomer.status }
        </div>
        { driversPanel }
        <GroomerActivity groomer={groomer}/>
      </Modal>
    )
  }
}


/** Informations diverses sur la dameuse */
let GroomerActivity = ({groomer}) => {
  const {messages_count, justifications_count, alerts_count} = groomer;
  const getValue = (count) => !count || count.length === 0 ? 0 : count[0].aggregate;
  return (
    <div className="activities">
      <div className="activity">
        <i className="mi mi-settings"/>
        <span>Messages</span>
        <span> {getValue(messages_count)} </span>
      </div>
      <div className="activity">
        <i className="mi mi-settings"/>
        <span>Justifications</span>
        <span> {getValue(justifications_count)} </span>
      </div>
      <div className="activity">
        <i className="mi mi-settings"/>
        <span>Alertes</span>
        <span>{getValue(alerts_count)}</span>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/SupportMessages/GroomerPopup.js